var _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.1927 10.2006L18.1283 7.85315L13.9673 12.0141L18.128 16.1748L22.2065 13.8195C22.8425 13.4331 23.222 12.7581 23.222 12.0141C23.222 11.2701 22.8422 10.5951 22.1927 10.2006Z",
    fill: "#FFCE00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9673 12.0141L2.6336 0.598877C2.2394 0.993076 2 1.52797 2 2.11927V21.8742C2 22.4655 2.2394 23.0004 2.6336 23.3949L13.9673 12.0141Z",
    fill: "url(#paint0_linear_102_101)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9672 12.0141L18.1282 7.85315L18.1348 7.84655L12.5596 4.63656L5.21024 0.317177C4.54844 -0.0911215 3.74594 -0.105221 3.07004 0.274877C2.91524 0.373277 2.77424 0.471977 2.63354 0.598576L13.9672 12.0141Z",
    fill: "#00F076"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.63354 23.3946C2.77424 23.5212 2.91524 23.6199 3.07004 23.7183C3.40784 23.9013 3.76004 24 4.11194 24C4.49204 24 4.85804 23.8875 5.19614 23.6904L12.5593 19.3917L18.1345 16.1817L18.1279 16.1751L13.9672 12.0141L2.63354 23.3946Z",
    fill: "#F63448"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_102_101",
    x1: -3.06518,
    y1: 17.6958,
    x2: 8.33268,
    y2: 6.29766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C5FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlaystore);
export default __webpack_public_path__ + "static/media/GooglePlaystore.a49c4a5afdc0eabc24bdaa6f515275b5.svg";
export { ForwardRef as ReactComponent };